// update rank
// import ref from './_state';


export default function (ref) {

    ref.dom.select('#js-rank')
            .text(ref.data[ref.activeIndex].rank);

}